import { useState, useEffect } from 'react';
import type { VendorCategory, ExpenseStatus } from '@peles/shared';
import { FilterSelect } from '../common';

export interface ExpenseFiltersState {
  search: string;
  vendorCategoryIds: string[];
  statusIds: string[];
}

interface ExpenseFiltersProps {
  filters: ExpenseFiltersState;
  onFiltersChange: (filters: ExpenseFiltersState) => void;
  categories: VendorCategory[];
  statuses: ExpenseStatus[];
}

export function ExpenseFilters({
  filters,
  onFiltersChange,
  categories,
  statuses,
}: ExpenseFiltersProps) {
  const [searchInput, setSearchInput] = useState(filters.search);

  // Debounce search input
  useEffect(() => {
    const timer = setTimeout(() => {
      if (searchInput !== filters.search) {
        onFiltersChange({ ...filters, search: searchInput });
      }
    }, 300);
    return () => clearTimeout(timer);
  }, [searchInput, filters, onFiltersChange]);

  return (
    <div className="flex flex-wrap items-center gap-2 mb-4">
      <input
        type="text"
        placeholder="Search by vendor or item name..."
        value={searchInput}
        onChange={(e) => setSearchInput(e.target.value)}
        className="px-3 py-2 border border-gray-300 rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-primary-500 focus:border-transparent w-full sm:w-64"
      />
      <FilterSelect
        label="All Categories"
        items={categories}
        value={filters.vendorCategoryIds}
        onChange={(value) => onFiltersChange({ ...filters, vendorCategoryIds: value as string[] })}
        getValue={(c) => c.id}
        getLabel={(c) => c.name}
        multiple
      />
      <FilterSelect
        label="All Statuses"
        items={statuses}
        value={filters.statusIds}
        onChange={(value) => onFiltersChange({ ...filters, statusIds: value as string[] })}
        getValue={(s) => s.id}
        getLabel={(s) => s.name}
        multiple
      />
    </div>
  );
}
